import React from 'react'

const AuthError = ({ error }) => {
  return (
    <div className="login-spinner">
      <div className="login-spinner-message">{error}</div>
    </div>
  )
}

export default AuthError
